export default __webpack_public_path__ + "static/10559-8f75b671c8cc63a4fec473f89c57ebb0.jpg";